import { Type } from 'class-transformer';
import { Equals, IsArray, IsIn, ValidateNested } from 'class-validator';
import { v4 as uuid } from 'uuid';

import {
  FilterType,
  QUERY_OPERATOR_TYPE_KEYS,
  QueryOperator,
  RULE_TYPE_QUERY,
} from './consts';
import { FunctionalGroupRule } from './functional-group-rule';
import { NumberRule } from './number-rule';
import { TextRule } from './text-rule';

export type Rule = Query | FunctionalGroupRule | NumberRule | TextRule;
export class Query {
  constructor() {
    this.type = RULE_TYPE_QUERY;
    this.operator = QueryOperator.AND;
    this.rules = [];

    this.key = uuid();
  }

  @Equals(RULE_TYPE_QUERY)
  type: typeof RULE_TYPE_QUERY;

  @IsIn(QUERY_OPERATOR_TYPE_KEYS)
  operator: QueryOperator;

  @IsArray()
  @ValidateNested()
  @Type(() => Query, {
    keepDiscriminatorProperty: true,
    discriminator: {
      property: 'type',
      subTypes: [
        { value: FunctionalGroupRule, name: FilterType.FUNCTIONAL_GROUP },
        { value: TextRule, name: FilterType.TEXT },
        { value: NumberRule, name: FilterType.NUMBER },
      ],
    },
  })
  rules: Array<Rule>;

  key: string;
}
